/**
 * Common Google AdSense block widget mixin
 *
 * Required params:
 * - query : the query string e.g. name of article, default is "hotel"
 *
 * for further param description see https://developers.google.com/custom-search-ads/docs/reference#params
 */
import client from "./client";
import { langId } from "@escapio/shared/l10n/lang-id";

const DEFAULT_PAGE_OPTIONS = {
	hl: langId,
	pubId: "partner-pub-5407372265807589",
	styleId: "6789636033",
};

const DEFAULT_AD_UNIT_OPTIONS = {
	width: "100%",
	number: 4,
};

export default class extends HTMLElement {
	constructor() {
		super();
		this.started = false;
		this.iframeIsVisible = false;
	}

	/**
	 * Adds a AdSense block using the client,
	 * make sure widgets dom node is visible
	 * otherwise Google AdSense will kind of disable itself
	 */
	addAdSense() {
		if (this.started) {
			return;
		}

		const pageOptions = {
			...DEFAULT_PAGE_OPTIONS,
			query: this.getAttribute("query") || "hotel",
		};

		const adBlock = {
			...DEFAULT_AD_UNIT_OPTIONS,
			container: this.id || this,
		};

		client("ads", pageOptions, adBlock);
		this.started = true;

		// Wait for iframe to become ready.
		const iframeIsReady = new Promise(resolver => {
			const observer = new MutationObserver(() => {
				const iframe = this.children[1];
				if (iframe instanceof HTMLElement) {
					resolver(iframe);
				}
			});
			observer.observe(this, {
				childList: true,
			});
		});

		// Watch for visibility of iframe.
		iframeIsReady.then(iframe => {
			const observer = new MutationObserver(() => {
				if (iframe.style.visibility === "hidden") {
					this.iframeIsVisible = false;
					this.updateVisibility();
				}
				if (iframe.style.visibility === "visible") {
					this.iframeIsVisible = true;
					this.updateVisibility();
				}
			});
			observer.observe(iframe, {
				attributes: true,
				attributeFilter: ["style"],
			});
		});
	}

	isVisible() {
		return this.iframeIsVisible;
	}

	updateVisibility() {
		if (!this.started) {
			return;
		}
		if (this.isVisible()) {
			this.classList.add("adsense-wrapper--visible");
		} else {
			this.classList.remove("adsense-wrapper--visible");
		}
	}
}
